function Amount({amount, currency}) {

    let sign;

    switch (currency) {
        case "RUB":
            sign = "₽"
            break;
        case "EUR":
            sign = "€"
            break;
        case "USD":
        case "CAD":
            sign = "$"
            break;
        case "INR":
            sign = "₹"
            break;
        case "JPY":
        case "CNY":
            sign = "¥"
            break;
        case "CNF":
            sign = "₣"
            break;
        case "TRY":
            sign = "₺"
            break;
        case "UAH":
            sign = "₴"
            break;
        default:
            sign = String(currency)
    }

    return Number(amount).toLocaleString() + sign;
}

export default Amount;


// WEBPACK FOOTER //
// ./src/Components/Utils/Amount/index.js